<template>
    <div id="WelcomeSupsisViews">
        <h1>Welcome Supsis</h1>

        <div class="preview-section">
            <h2>Seçilen AI Sistemleri</h2>
            <div class="system-grid">
                <div
                    v-for="(value, key) in systemOptions"
                    :key="key"
                    class="system-card"
                    :class="{ active: value }"
                >
                    <div class="icon-container">
                        <span v-if="value" class="check-icon">✓</span>
                    </div>
                    <div class="system-name">
                        {{ systemLabels[key] }}
                    </div>
                </div>
            </div>
        </div>

        <div class="preview-section">
            <h2>Entegre Edilen Modüller</h2>

            <div v-if="communicationModules.length" class="module-category">
                <h3>Temel İletişim Modülleri</h3>
                <div class="module-grid">
                    <div
                        v-for="(module, index) in communicationModules"
                        :key="'comm-'+index"
                        class="module-card"
                    >
                        <div class="module-icon">{{ getModuleIcon(module) }}</div>
                        <div class="module-name">{{ getModuleLabel(module) }}</div>
                    </div>
                </div>
            </div>

            <div v-if="businessModules.length" class="module-category">
                <h3>İş Yönetim Modülleri</h3>
                <div class="module-grid">
                    <div
                        v-for="(module, index) in businessModules"
                        :key="'biz-'+index"
                        class="module-card"
                    >
                        <div class="module-icon">{{ getModuleIcon(module) }}</div>
                        <div class="module-name">{{ getModuleLabel(module) }}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="preview-section">
            <h2>Anket Bilgileri</h2>
            <div class="survey-info">
                <div class="info-item">
                    <span class="info-label">Sektör:</span>
                    {{ surveySector }}
                </div>
                <div class="info-item">
                    <span class="info-label">Departman:</span>
                    {{ surveyDepartment }}
                </div>
                <div class="info-item">
                    <span class="info-label">Bizi Duyma Kanalları:</span>
                    {{ heardAboutUs }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "WelcomeSupsisViews",
    props: {
        siteId: {
            type: String,
            required: true,
        },
        siteData: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            systemLabels: {
                aiChatbot: 'AI Chatbot',
                aiAssistant: 'AI Asistan',
                aiLiveSupport: 'Canlı Destek',
                aiAutomation: 'Otomasyon',
                aiDynamicCrm: 'Dinamik CRM'
            },
            moduleLabels: {
                whatsappBusiness: 'Whatsapp Business',
                whatsappWeb: 'Whatsapp Web',
                instagram: 'Instagram',
                facebook: 'Facebook',
                telegram: 'Telegram',
                mail: 'E-posta Yönetimi',
                webChat: 'Web Sohbet',
                ai: 'AI Entegrasyon',
                metaLead: 'Meta Lead',
                trendyol: 'Trendyol',
                formSurvey: 'Form & Anket',
                processManagement: 'Süreç Yönetimi',
                videoCall: 'Video Görüşme',
                calendar: 'Takvim Sistem',
                websiteAnalysis: 'Web Site Analiz',
                adReporting: 'Reklam Analiz',
                ticketSystem: 'Ticket Sistemi',
                webPush: 'Web Push',
                remarketing: 'Re-Marketing',
                dynamicTables: 'Dinamik Tablolar'
            }
        };
    },
    computed: {
        lobbyData() {
            return this.siteData.lobbyData || {};
        },
        systemOptions() {
            return this.lobbyData.systemOptions || {};
        },
        communicationModules() {
            return this.getActiveModules(this.lobbyData.moduleSelections);
        },
        businessModules() {
            return this.getActiveModules(this.lobbyData.moduleSelectionsTwo);
        },
        surveyAnswers() {
            return this.lobbyData.surveyAnswers || {};
        },
        surveySector() {
            const sector = this.surveyAnswers.sector || '';
            return sector === 'Diger'
                ? this.surveyAnswers.otherSector || 'Belirtilmemiş'
                : sector;
        },
        surveyDepartment() {
            const department = this.surveyAnswers.department || '';
            return department === 'Diger'
                ? this.surveyAnswers.otherDepartment || 'Belirtilmemiş'
                : department;
        },
        heardAboutUs() {
            return (this.surveyAnswers.heardAboutUs || []).join(', ') || 'Belirtilmemiş';
        }
    },
    methods: {
        getActiveModules(modules) {
            if (!modules) return [];
            return Object.entries(modules)
                .filter(([_, value]) => value)
                .map(([key]) => key);
        },
        getModuleIcon(moduleKey) {
            const icons = {
                whatsappBusiness: '✆',
                instagram: '📸',
                remarketing: '📈',
                videoCall: '📹',
                facebook: '📘',
                telegram: '📨',
                mail: '📧',
                webChat: '💬',
                ai: '🤖',
                metaLead: '🔍',
                trendyol: '🛍️',
                formSurvey: '📝',
                processManagement: '📊',
                calendar: '📅',
                websiteAnalysis: '📈',
                adReporting: '📊',
                ticketSystem: '🎫',
                webPush: '🔔',
                dynamicTables: '📑'
            };
            return icons[moduleKey] || '✔';
        },
        getModuleLabel(moduleKey) {
            return this.moduleLabels[moduleKey] || moduleKey;
        }
    }
};
</script>
<style lang="scss" scoped>
.preview-section {
    background: rgba(255, 255, 255, 0.9);
    border-radius: 15px;
    padding: 20px;
    margin: 20px 0;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

    h2 {
        color: #272657;
        font-size: 1.5rem;
        margin-bottom: 1rem;
        border-bottom: 2px solid #5d5b8d;
        padding-bottom: 0.5rem;
    }
}

.system-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 15px;

    .system-card {
        background: #f8f8ff;
        border: 2px solid #e6e6fa;
        border-radius: 10px;
        padding: 15px;
        transition: all 0.3s ease;

        &.active {
            border-color: #5d5b8d;
            background: linear-gradient(145deg, #ffffff, #f0f0ff);

            .check-icon {
                color: #4CAF50;
                font-weight: bold;
            }
        }

        .system-name {
            color: #272657;
            font-weight: 500;
            margin-top: 10px;
        }
    }
}

.module-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 15px;

    .module-card {
        background: white;
        border-radius: 10px;
        padding: 15px;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        display: flex;
        align-items: center;

        .module-icon {
            font-size: 24px;
            margin-right: 15px;
            width: 40px;
            text-align: center;
        }

        .module-name {
            color: #272657;
            font-weight: 500;
        }
    }
}

.survey-info {
    .info-item {
        padding: 10px;
        background: #f9f9ff;
        margin: 10px 0;
        border-radius: 8px;

        .info-label {
            color: #5d5b8d;
            font-weight: 600;
            margin-right: 10px;
        }
    }
}

.module-category {
    margin: 25px 0;

    h3 {
        color: #5d5b8d;
        font-size: 1.2rem;
        margin-bottom: 15px;
        padding-left: 10px;
        border-left: 4px solid #5d5b8d;
    }
}

@media (max-width: 768px) {
    .system-grid,
    .module-grid {
        grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    }

    .preview-section {
        padding: 15px;

        h2 {
            font-size: 1.3rem;
        }
    }
}
</style>
